import { Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import luciLogo from '../../../assets/luciLogo2.png';
import CustomUserCard from '../../events/components/CustomUserCard';
import '@fontsource/rubik';

const NAV_TABS = [
  { label: 'Main Dashboard', path: '/' },
];

// Shown only to the account owner; the page and the API re-check.
const OWNER_TABS = [
  { label: 'Account Dashboard', path: '/customer-dashboard' },
  { label: 'Credits', path: '/credits' },
];

export default function CustomerDashboardNavbar() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const isOwner   = useSelector((state) => !!state.root.commonReducer?.is_account_owner);
  const tabs      = isOwner ? [...NAV_TABS, ...OWNER_TABS] : NAV_TABS;

  return (
    <Box
      id="cd-navbar"
      sx={{
        height: '60px',
        borderBottom: '1px solid #E9EBE9',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        px: '28px',
        gap: '28px',
        position: 'sticky',
        top: 0,
        zIndex: 30,
        flexShrink: 0,
      }}
    >
      {/* ── Brand ── */}
      <Box
        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        onClick={() => navigate('/customer-dashboard')}
      >
        <Box
          component="img"
          src={luciLogo}
          alt="Lucihub"
          sx={{ height: '28px', objectFit: 'contain', display: 'block' }}
        />
      </Box>

      {/* ── Nav tabs ── */}
      <Box sx={{ display: 'flex', gap: '4px', ml: '8px' }}>
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          return (
            <Box
              key={tab.label}
              id={tab.label === 'Main Dashboard' ? 'cd-main-dashboard-tab' : undefined}
              component="button"
              onClick={() => tab.path && navigate(tab.path)}
              sx={{
                background: isActive ? '#08231B' : 'transparent',
                border: 0,
                cursor: tab.path ? 'pointer' : 'default',
                px: '14px',
                py: '7px',
                borderRadius: '8px',
                fontFamily: 'Rubik',
                fontWeight: 500,
                fontSize: '14px',
                color: isActive ? '#fff' : '#282831',
                transition: 'background 0.15s',
                '&:hover': {
                  background: isActive ? '#08231B' : '#f1f1ed',
                },
              }}
            >
              {tab.label}
            </Box>
          );
        })}
      </Box>

      {/* ── Right: user card ── */}
      <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
        <CustomUserCard size="small" />
      </Box>
    </Box>
  );
}
